import { render, staticRenderFns } from "./transformationsModal.vue?vue&type=template&id=b2e0e6cc&"
import script from "./transformationsModal.vue?vue&type=script&lang=js&"
export * from "./transformationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports